import { Link } from 'react-router-dom';
import { animeCategories } from '@/mocks/anime';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            动漫分类导航
          </h2>
          <p className="text-sm text-foreground-500">探索你喜欢的动漫类型</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {animeCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-white rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-50 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-500`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{cat.count} 部作品</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}